module.exports = __webpack_public_path__ + "assets/img/精细运营.e4bb6d7a.jpg";